<template>
    <div class="NoticeStyle">
        <div class="notice_bg mt-1 br-16">
            <div class="notice_flex" v-for="(item, index) in NoticeList" :key="index" @click="getpath(item)">
                <img :src="item.img" alt="" :style="{ width: item.width, height: item.height }" v-if="item.img">
                <div class="notice_width notice_font" v-if="item.title">{{ item.title }}</div>
                <div class="notice_ellipsis" v-if="item.content">
                    {{ item.content }}
                </div>
                <div v-if="item.PathImg">
                    <img :src="item.PathImg" alt="" :style="{ width: item.width, height: item.height }"
                        style="vertical-align:middle">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NoticeComponents',
    props: {
        NoticeList: {
            type: Array,
            default: []
        },

    },
    methods: {

        getpath(item) {
            this.$emit('Path', item);
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./index.scss";
</style>